export class UIElement {
  public readonly element = document.createElement("div");

  dispose() {}
}
